import React, { useState } from "react";
import {
  Fab,
  Drawer,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Divider,
  Box,
  Typography,
  Tooltip,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import FeatherIcon from "feather-icons-react";
import {
  setTheme,
  setDir,
  setDarkMode,
} from "../../../redux/customizer/Action";
import CustomRadio from "../../../components/forms/custom-elements/CustomRadio";

const SidebarWidth = "320px";

const Customizer = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const customizer = useSelector((state) => state.CustomizerReducer);
  const dispatch = useDispatch();
  const thColors = [
    {
      id: 1,
      bgColor: "#1a9bfc",
      disp: "BLUE_THEME",
    },
    {
      id: 2,
      bgColor: "#00cec3",
      disp: "GREEN_THEME",
    },
    {
      id: 3,
      bgColor: "#7352ff",
      disp: "PURPLE_THEME",
    },
    {
      id: 4,
      bgColor: "#ff5c8e",
      disp: "RED_THEME",
    },
    {
      id: 5,
      bgColor: "#1e4db7",
      disp: "INDIGO_THEME",
    },
    {
      id: 6,
      bgColor: "#fb9678",
      disp: "ORANGE_THEME",
    },
  ];
  return (
    <div>
      <Tooltip title="Diwali Settings" placement="left">
        <Fab
          aria-label="settings"
          onClick={() => setShowDrawer(true)}
          sx={{
            position: "fixed",
            right: "18px",
            bottom: "18px",
            width: 60,
            height: 60,
            minHeight: 60,
            borderRadius: "50%",
            color: "#fff8e8",
            background: `
        radial-gradient(
          circle at 35% 25%,
          #ffbd55 0%,
          #ff8a2d 35%,
          #ed571b 70%,
          #c83b12 100%
        )
      `,
            border: "2px solid #ffda91",
            boxShadow: `
        0 0 0 3px rgba(255, 180, 70, 0.16),
        0 4px 12px rgba(191, 83, 19, 0.30),
        0 0 18px rgba(255, 174, 55, 0.20)
      `,
            overflow: "hidden",
            transition: "all 0.3s ease",

            "&::before": {
              content: '""',
              position: "absolute",
              inset: "4px",
              border: "1px solid rgba(255, 235, 184, 0.8)",
              borderRadius: "50%",
              pointerEvents: "none",
            },

            "&:hover": {
              background: `
          radial-gradient(
            circle at 35% 25%,
            #ffd17b,
            #ff8426 55%,
            #d94312
          )
        `,
              transform: "translateY(-3px) scale(1.05)",
              boxShadow: `
          0 0 0 4px rgba(255, 180, 70, 0.20),
          0 7px 18px rgba(191, 83, 19, 0.35)
        `,
            },

            "&:active": {
              transform: "scale(0.96)",
            },
          }}
        >
          <FeatherIcon
            icon="settings"
            size={23}
            style={{
              position: "relative",
              zIndex: 2,
              color: "#fff8e8",
            }}
          />
        </Fab>
      </Tooltip>
      <Drawer
        anchor="right"
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
        PaperProps={{
          sx: {
            width: SidebarWidth,
          },
        }}
      >
        <Box p={2}>
          <Typography variant="h3">Settings</Typography>
        </Box>
        <Divider />
        <Box p={2}>
          {/* ------------ Dark light theme setting ------------- */}
          <Typography variant="h4" gutterBottom>
            Theme Option
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="theme"
              name="theme"
              value={customizer.activeMode}
              onChange={(event) => dispatch(setDarkMode(event.target.value))}
            >
              <FormControlLabel
                value="light"
                control={<CustomRadio />}
                label="Light"
              />
              <FormControlLabel
                value="dark"
                control={<CustomRadio />}
                label="Dark"
              />
            </RadioGroup>
          </FormControl>
          <Box pt={3} />
          {/* ------------ RTL theme setting -------------*/}
          <Typography variant="h4" gutterBottom>
            Theme Direction
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="themedir"
              name="themedir"
              value={customizer.activeDir}
              onChange={(event) => dispatch(setDir(event.target.value))}
            >
              <FormControlLabel
                value="ltr"
                control={<CustomRadio />}
                label="LTR"
              />
              <FormControlLabel
                value="rtl"
                control={<CustomRadio />}
                label="RTL"
              />
            </RadioGroup>
          </FormControl>
          <Box pt={3} />
          {/* ------------ Navbar Color setting ------------- */}
          <Typography variant="h4" gutterBottom>
            Theme Colors
          </Typography>
          {thColors.map((thcolor) => (
            <Tooltip title={thcolor.disp} placement="top" key={thcolor.id}>
              <Fab
                color="primary"
                style={{ backgroundColor: thcolor.bgColor }}
                sx={{ marginRight: "3px" }}
                size="small"
                onClick={() => dispatch(setTheme(thcolor.disp))}
                aria-label={thcolor.bgcolor}
              >
                {customizer.activeTheme === thcolor.disp ? (
                  <FeatherIcon icon="check" size="16" />
                ) : (
                  ""
                )}
              </Fab>
            </Tooltip>
          ))}

          <Box pt={3} />
        </Box>
      </Drawer>
    </div>
  );
};

export default Customizer;
